import { Grid, Modal } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';
import siteLogo from 'assets/images/logo.svg';
import waterMark from 'assets/images/preview-mode-water-mark.png';
import { CustomButton } from 'components/common';

const useStyles = makeStyles((theme) => ({
  CustomModal: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgb(229,229,229,0.5)',
  },
  modal: {
    maxWidth: '900px',
    outline: 'none',
    width: '70%',
    height: '90%',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  insiderModal: {
    backgroundColor: '#fff',
  },
  modalHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    paddingBottom: '8px',
    padding: [[15, 10, 30, 30]],

    [theme.breakpoints.down('sm')]: {
      padding: [[15, 15, 15, 30]],
    },

    '& img': {
      cursor: 'pointer',
    },
    '& svg': {
      cursor: 'pointer',
    },
  },
  modalBody: {
    padding: [[7, 20, 0, 20]],
  },
  closeIcon: {
    cursor: 'pointer',
  },
  PreviewImage: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    width: '150px',
    height: '150px',
    '& img': {
      width: '150px',
      height: '150px',
    },
  },
  PreviewContent: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    height: '100%',
    marginLeft: '37px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
    },
    '& p': {
      margin: '0px',
      fontWeight: 'normal',
      fontSize: '18px',
      lineHeight: '30px',
      color: 'rgba(17, 17, 17, 0.7)',
      wordBreak: 'break-word',
      fontFamily: 'Roboto',
      [theme.breakpoints.down('sm')]: {
        marginTop: '15px',
      },
    },
  },
  problemBox: {
    display: 'block',
    '& h6': {
      margin: '0px',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 18,
      lineHeight: '28px',
      color: '#111111',
      paddingTop: '30px',
      paddingBottom: '10px',
      position: 'relative',
      fontFamily: 'Roboto',

      '&::before': {
        content: "''",
        borderBottom: '1px solid rgba(17, 17, 17, 0.2)',
        position: 'absolute',
        left: '0px',
        bottom: '1px',
        right: '18px',
        width: '150px',
        height: '1px',
      },
    },
    '& p': {
      fontWeight: 'normal',
      fontSize: 16,
      lineHeight: '24px',
      color: 'rgba(17, 17, 17, 0.7)',
      margin: '0px',
      paddingTop: '16px',
      paddingRight: '53px',
      wordBreak: 'break-word',
      fontFamily: 'Roboto',
    },
  },
  marketBox: {
    display: 'block',
    '& h6': {
      margin: '0px',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 18,
      lineHeight: '28px',
      color: '#111111',
      paddingTop: '30px',
      paddingBottom: '10px',
      position: 'relative',
      fontFamily: 'Roboto',

      '&::before': {
        content: "''",
        borderBottom: '1px solid rgba(17, 17, 17, 0.2)',
        position: 'absolute',
        left: '0px',
        bottom: '1px',
        right: '18px',
        width: '150px',
        height: '1px',
      },
    },
    '& ul': {
      marginTop: '16px',
      paddingLeft: '0px',
      '& li': {
        display: 'flex',
        alignItems: 'center',

        '&:last-child': {
          '& h5': {
            fontWeight: 500,
            fontSize: 16,
            lineHeight: '28px',
            color: 'rgba(17, 17, 17, 0.7)',
            margin: '0px auto 0px 0px',
            fontFamily: 'Roboto',
          },
          '& p': {
            marginRight: '5px',
            margin: '0px',
            fontWeight: 500,
            fontSize: 16,
            lineHeight: '28px',
            color: 'rgba(17, 17, 17, 0.7)',
            fontFamily: 'Roboto',
          },
        },
        '& h5': {
          fontWeight: 'normal',
          fontSize: 16,
          lineHeight: '28px',
          color: 'rgba(17, 17, 17, 0.7)',
          margin: '0px auto 0px 0px',
          fontFamily: 'Roboto',
        },
        '& p': {
          marginRight: '5px',
          margin: '0px',
          fontWeight: 'normal',
          fontSize: 16,
          lineHeight: '28px',
          color: 'rgba(17, 17, 17, 0.7)',
          fontFamily: 'Roboto',
        },
      },
    },
  },
  revenueModal: {
    display: 'block',
    '& h6': {
      margin: '0px',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 18,
      lineHeight: '28px',
      color: '#111111',
      paddingTop: '30px',
      paddingBottom: '10px',
      position: 'relative',
      fontFamily: 'Roboto',

      '&::before': {
        content: "''",
        borderBottom: '1px solid rgba(17, 17, 17, 0.2)',
        position: 'absolute',
        left: '0px',
        bottom: '1px',
        right: '18px',
        width: '150px',
        height: '1px',
      },
    },

    '& ul': {
      marginTop: '10px',
      '& li': {
        fontWeight: 'normal',
        fontSize: 16,
        lineHeight: '30px',
        color: 'rgba(17, 17, 17, 0.7)',
        listStyleType: 'disc',
        marginLeft: '20px',
        wordBreak: 'break-word',
        fontFamily: 'Roboto',
        '&:marker': {
          left: '15px',
        },
      },
    },
  },
  projectSection: {
    marginBottom: '40px',
    '& h6': {
      margin: '0px 0px 20px 0px',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 18,
      lineHeight: '28px',
      color: '#111111',
      paddingTop: '30px',
      paddingBottom: '10px',
      position: 'relative',
      fontFamily: 'Roboto',

      '&::before': {
        content: "''",
        borderBottom: '1px solid rgba(17, 17, 17, 0.2)',
        position: 'absolute',
        left: '0px',
        bottom: '1px',
        right: '18px',
        width: '150px',
        height: '1px',
      },
    },
  },
  TeamBox: {
    '& h6': {
      margin: '0px 0px 22px 0px',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 18,
      lineHeight: '28px',
      color: '#111111',
      paddingTop: '26px',
      paddingBottom: '10px',
      position: 'relative',
      fontFamily: 'Roboto',

      '&::before': {
        content: "''",
        borderBottom: '1px solid rgba(17, 17, 17, 0.2)',
        position: 'absolute',
        left: '0px',
        bottom: '1px',
        right: '18px',
        width: '150px',
        height: '1px',
      },
    },
  },

  projectionTable: {
    display: 'block',
    backgroundColor: '#fff',
    maxWidth: 860,
    overflowX: 'auto',
    '& table': {
      // width: 'max-content',
      // minWidth: 800,
      width: '100%',
      borderCollapse: 'collapse',

      '& tr': {
        '& td:first-child': {
          fontWeight: 'normal',
          fontSize: 16,
          lineHeight: 1,
          color: '#111111',
          padding: [[0, 0, 0, 21]],
          width: 130,
          height: 60,
          fontFamily: 'Roboto',
          border: '1px solid #DFDFDF',
        },

        '& td': {
          border: '1px solid #DFDFDF',
          width: 144,
          // height: 75,
          padding: [[0, 0, 0, 21]],
        },
      },
    },
  },

  teamMember: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    '& h4': {
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '26px',
      color: 'rgba(17, 17, 17, 0.7)',
      margin: '0px',
      paddingTop: '4px',
      fontFamily: 'Roboto',
    },
    '& h5': {
      fontWeight: 'normal',
      fontSize: 12,
      lineHeight: '26px',
      margin: '0px',
      color: 'rgba(17, 17, 17, 0.3)',
      textAlign: 'center',
      fontFamily: 'Roboto',
    },
  },
  memberImg: {
    width: 80,
    height: 80,
    background: '#F9F9F9',
    borderRadius: '50%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: '80px',
      height: '80px',
      borderRadius: '50%',
    },
  },
  fundingAsk: {
    display: 'block',
    padding: [[26, 0, 0, 44]],
    background: '#FAFAFA',
    minHeight: '422px',
    [theme.breakpoints.down('md')]: {
      marginTop: '40px',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '40px',
      padding: '26px 10px 0 10px',
    },
    '& h6': {
      margin: '0px 0px 22px 0px',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 18,
      lineHeight: '28px',
      color: '#111111',
      paddingBottom: '10px',
      position: 'relative',
      fontFamily: 'Roboto',

      '&::before': {
        content: "''",
        borderBottom: '1px solid rgba(17, 17, 17, 0.2)',
        position: 'absolute',
        left: '0px',
        bottom: '1px',
        right: '18px',
        width: '150px',
        height: '1px',
      },
    },
  },
  TeamAndAskSection: {
    [theme.breakpoints.down('md')]: {
      paddingRight: '30px',
    },
  },
  fundingAmount: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    height: '100%',
  },
  fundAmount: {
    display: 'flex !important',
    flexWrap: 'wrap !important',
    '& span': {
      fontWeight: 500,
      fontSize: 40,
      lineHeight: '47px',
      marginRight: '5px',
      color: '#111111',
      fontFamily: 'Roboto',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        textAlign: 'center',
        paddingBottom: '10px',
        fontSize: '20px',
      },
    },
  },
  fundingAmountImg: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: '245px',
      height: '245px',
    },
  },
  modalFooter: {
    borderTop: '1px solid rgba(17, 17, 17, 0.2)',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: [[14, 28, 17, 30]],
  },
  footerLogo: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'center',
    '& p': {
      fontWeight: 'normal',
      fontSize: 12,
      lineHeight: '14px',
      color: 'rgba(17, 17, 17, 0.3)',
      margin: '0px 0px 3px 0px',
      fontFamily: 'Roboto',
    },
    '& img': {
      width: '41px',
      height: '25px',
    },
  },
  contactDetails: {
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      marginTop: '15px',
    },
    '& ul': {
      display: 'flex',
      paddingTop: '10px',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
      },

      '& li': {
        marginRight: '20px',
        listStyleType: 'none',
        [theme.breakpoints.down('xs')]: {
          marginRight: '10px',
        },
        '& .MuiSvgIcon-root': {
          width: '11px',
          height: '11px',
          marginRight: '12px',
        },
        '&:first-child': {
          '& .MuiSvgIcon-root': {
            width: '16px',
            height: '16px',
            marginRight: '8px',
          },
          '& span': {
            fontWeight: 500,
            fontSize: 16,
            lineHeight: '19px',
            color: '#111111',
            fontFamily: 'Roboto',
          },
        },
        '& span': {
          fontWeight: 'normal',
          fontSize: 16,
          lineHeight: '19px',
          color: '#111111',
          fontFamily: 'Roboto',
          [theme.breakpoints.down('xs')]: {
            fontSize: 13,
          },
          [theme.breakpoints.down(321)]: {
            fontSize: 10,
          },
        },
      },
    },
  },
  downloadOnePageBtn: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '50px',
    paddingBottom: '50px',
    '& button': {
      minWidth: '250px',
      [theme.breakpoints.down(321)]: {
        padding: '20px',
        minWidth: '211px',
      },
    },
  },
  previewModeWaterMark: {
    backgroundImage: `url(${waterMark})`,
    backgroundRepeat: 'repeat-y',
    backgroundSize: '80%',
  },
  ProjectionAmountTd: {
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: 1,
    color: '#111111',
    margin: '0px 0px 0px -12px',
    fontFamily: 'Roboto',
  },
  subText: {
    fontSize: '11px',
    color: 'rgba(17, 17, 17, 0.7)',
    fontWeight: 'normal',
    lineHeight: '20px',
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '-5px',
  },
  submitButton: {
    backgroundColor: '#008B5E',
    minWidth: '250px',
    height: '60px',
    border: '1px solid #008B5E',
    fontSize: '18px',
    color: '#fff',
    borderRadius: '100px',
    padding: '23px 52',
  },
}));

export default function OnePagerPreviewModal({
  openPreviewModal,
  data,
  openEmailModal,
  openPreviewModalClose,
  currencyState,
}) {
  const classes = useStyles();
  return (
    <Modal
      className={classes.CustomModal}
      open={openPreviewModal}
      onClose={openPreviewModalClose}
      closeAfterTransition
    >
      <div className={classes.modal}>
        <div className={classes.insiderModal}>
          <div className={classes.modalHeader}>
            <CloseIcon
              className={classes.closeIcon}
              width={24}
              height={24}
              onClick={openPreviewModalClose}
            />
          </div>
          <div className={classes.modalBody}>
            <div className={classes.previewModeWaterMark}>
              <Grid container>
                <Grid item xs={12} md={2} lg={2}>
                  <div className={classes.PreviewImage}>
                    <img
                      src={
                        data &&
                        data.companyLogo &&
                        URL.createObjectURL(data.companyLogo)
                      }
                      alt=""
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={10} lg={10}>
                  <div className={classes.PreviewContent}>
                    <p>{data && data.company_description}</p>
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={12} lg={8}>
                  <Grid container>
                    <Grid item xs={12} sm={12} lg={6}>
                      <div className={classes.problemBox}>
                        <h6>Problem</h6>
                        <p>{data && data.problem}</p>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <div className={classes.problemBox}>
                        <h6>Solution</h6>
                        <p>{data && data.solution}</p>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} lg={4}>
                  <div className={classes.marketBox}>
                    <h6>
                      Market {currencyState ? '(in Crores)' : '(in Million $)'}
                    </h6>
                    <ul>
                      <li>
                        <h5>
                          TAM{' '}
                          <span className={classes.subText}>
                            (Total Addressable Market)
                          </span>
                        </h5>
                        <p>{data && data.totalMarket}</p>
                        <span>{currencyState ? 'cr' : 'M$'}</span>
                      </li>
                      <li>
                        <h5>
                          SAM
                          <span className={classes.subText}>
                            (Service Addressable Market)
                          </span>
                        </h5>
                        <p>{data && data.serviceMarket}</p>
                        <span>{currencyState ? 'cr' : 'M$'}</span>
                      </li>
                      <li>
                        <h5>
                          SOM{' '}
                          <span className={classes.subText}>
                            (Service Obtainable Market)
                          </span>
                        </h5>
                        <p>{data && data.serviceObtMarket}</p>
                        <span>{currencyState ? 'cr' : 'M$'}</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={7}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <div className={classes.revenueModal}>
                    <h6>Competitive Landscape</h6>
                    <ul>
                      <li>{data && data.landscape}</li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <div className={classes.revenueModal}>
                    <h6>Revenue Model</h6>
                    <ul>
                      <li>{data && data.revenue}</li>
                    </ul>
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={12} lg={8}>
                  <Grid container spacing={4}>
                    <Grid item sm={12} md={6} lg={6}>
                      <div className={classes.revenueModal}>
                        <h6>Growth Strategy</h6>
                        <ul>
                          <li>{data && data.strategy}</li>
                        </ul>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <div className={classes.revenueModal}>
                        <h6>Market Traction</h6>
                        <ul>
                          <li>{data && data.traction}</li>
                        </ul>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <div className={classes.projectSection}>
                <h6>Projections</h6>
                <div className={classes.projectionTable}>
                  <table cellSpacing="0" cellPadding="0">
                    <tr>
                      <td>
                        <h1 className={classes.ProjectionAmountTd}>
                          {currencyState
                            ? '(Amount in Crores)'
                            : '(Amount in Million $)'}{' '}
                        </h1>
                      </td>
                      <td>{data && data?.yearOne}</td>
                      <td>{data && data?.yearTwo}</td>
                      <td>{data && data?.yearThree}</td>
                      <td>{data && data?.yearFour}</td>
                      <td>{data && data?.yearFive}</td>
                    </tr>
                    <tr>
                      <td>Revenue</td>
                      <td>{data && data?.revenueAmountOne}</td>
                      <td>{data && data?.revenueAmountTwo}</td>
                      <td>{data && data?.revenueAmountThree}</td>
                      <td>{data && data?.revenueAmountFour}</td>
                      <td>{data && data?.revenueAmountFive}</td>
                    </tr>
                    <tr>
                      <td>Expenses</td>
                      <td>{data && data?.expensesAmountOne}</td>
                      <td>{data && data?.expensesAmountTwo}</td>
                      <td>{data && data?.expensesAmountThree}</td>
                      <td>{data && data?.expensesAmountFour}</td>
                      <td>{data && data?.expensesAmountFive}</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div className={classes.TeamAndAskSection}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} lg={4}>
                    <div className={classes.TeamBox}>
                      <h6>Team</h6>
                      <Grid container spacing={3}>
                        {data && data.teamImageOne && data.teamImageOne.name && (
                          <Grid item xs={12} sm={6} lg={6}>
                            <div className={classes.teamMember}>
                              <div className={classes.memberImg}>
                                <img
                                  src={URL.createObjectURL(data.teamImageOne)}
                                  alt=""
                                />
                              </div>
                              <div>
                                <h4>{data && data.surnameOne}</h4>
                                <h5>{data && data.DesignationOne}</h5>
                              </div>
                            </div>
                          </Grid>
                        )}
                        {data && data.teamImageTwo && data.teamImageTwo.name && (
                          <Grid item xs={12} sm={6} lg={6}>
                            <div className={classes.teamMember}>
                              <div className={classes.memberImg}>
                                <img
                                  src={URL.createObjectURL(data.teamImageTwo)}
                                  alt=""
                                />
                              </div>
                              <div>
                                <h4> {data && data.surnameTwo}</h4>
                                <h5>{data && data.DesignationTwo}</h5>
                              </div>
                            </div>
                          </Grid>
                        )}
                        {data &&
                          data.teamImageThree &&
                          data.teamImageThree.name && (
                            <Grid item xs={12} sm={6} lg={6}>
                              <div className={classes.teamMember}>
                                <div className={classes.memberImg}>
                                  <img
                                    src={URL.createObjectURL(
                                      data.teamImageThree,
                                    )}
                                    alt=""
                                  />
                                </div>
                                <div>
                                  <h4>{data && data.surnameThree}</h4>
                                  <h5>{data && data.DesignationThree}</h5>
                                </div>
                              </div>
                            </Grid>
                          )}
                        {data && data.teamImageFour && data.teamImageFour.name && (
                          <Grid item xs={12} sm={6} lg={6}>
                            <div className={classes.teamMember}>
                              <div className={classes.memberImg}>
                                <img
                                  src={URL.createObjectURL(data.teamImageFour)}
                                  alt=""
                                />
                              </div>
                              <div>
                                <h4>{data && data.surnameFour}</h4>
                                <h5>{data && data.DesignationFour}</h5>
                              </div>
                            </div>
                          </Grid>
                        )}
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} lg={8}>
                    <div className={classes.fundingAsk}>
                      <h6>
                        Funding Ask {currencyState ? '(in lakhs)' : '(in $)'}
                      </h6>
                      <Grid container>
                        <Grid item xs={12} sm={12} md={5} lg={5}>
                          <div className={classes.fundingAmount}>
                            <div className={classes.fundAmount}>
                              <span>{data && data.fundAmount}</span>
                              <span>{currencyState ? 'lakhs' : '$'}</span>
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={7} lg={7}>
                          <div className={classes.fundingAmountImg}>
                            <img
                              src={
                                data &&
                                data.fundAskingImg &&
                                URL.createObjectURL(data.fundAskingImg)
                              }
                              alt=""
                            />
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
          <div className={classes.modalFooter}>
            <div className={classes.footerLogo}>
              <p>powered by</p>
              <img src={siteLogo.src} alt="" />
            </div>
            <div className={classes.contactDetails}>
              <ul>
                <li>
                  <PersonIcon />
                  <span>{data && data.fullName}</span>
                </li>
                <li>
                  <PhoneIcon />
                  <span>{data && data.mobileNumber}</span>
                </li>
                <li>
                  <MailIcon />
                  <span>{data && data.email}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={classes.downloadOnePageBtn}>
          <CustomButton
            className={classes.submitButton}
            onClick={openEmailModal}
          >
            <span>
              Download for Free <del>Rs.99</del>
            </span>
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
}
